module.exports = __webpack_public_path__ + "img/forekspleksi.ab44663f.jpg";